import { render, staticRenderFns } from "./ConvoUrl.vue?vue&type=template&id=75bd9240&scoped=true&"
import script from "./ConvoUrl.vue?vue&type=script&lang=js&"
export * from "./ConvoUrl.vue?vue&type=script&lang=js&"
import style0 from "./ConvoUrl.vue?vue&type=style&index=0&id=75bd9240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bd9240",
  null
  
)

export default component.exports